export default {
  // LvWYSIWYGEditor 預設工具列，順序即顯示順序
  buttons: [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'eraser',
    'ul',
    'ol',
    'font',
    'fontsize',
    'paragraph',
    'lineHeight',
    'superscript',
    'subscript',
    'spellcheck',
    'cut',
    'copy',
    'paste',
    'selectall',
    'copyformat',
    'hr',
    'table',
    'link',
    'symbols',
    'indent',
    'outdent',
    'left',
    'undo',
    'redo',
    'find',
    'fullsize',
    'preview',
    'source',
  ],
};
